import React from "react";

function ProfileSubscriptions() {
  return (
    <div>
      <h1>No paid subscriptions yet</h1>
      <p>Stay tuned for updated models!</p>
    </div>
  );
}

export default ProfileSubscriptions;